<template>
  <div class="main">
    <report-top v-if="scan != true"> </report-top>
    <selectTool>
      <div slot="item" class="selectToolItem">
        <div class="label"><p>时间</p></div>
        <start-end
          ref="startEnd"
          datetime="datetime"
          :day0="-3"
          timeModel="0,1"
        ></start-end>
      </div>
      <div slot="item" class="selectToolItem">
        <div class="label"><p>对象</p></div>
        <select-device
          style="width: 130px"
          :name="searchItem.bind"
          @update:name="searchItem.bind = $event"
          @update:deviceNo="searchItem.deviceNo = $event"
          @update:useType="useType = $event"
        ></select-device>
      </div>
      <div slot="item" class="selectToolItem">
        <div class="label"><p>模式</p></div>
        <Select
          @on-select="selectModel"
          v-model="searchItem.model"
          style="width: 120px"
        >
          <Option :value="1">里程回退</Option>
          <Option :value="2">设备离线</Option>
          <Option :value="3">没有信号</Option>
          <Option :value="4">ACC变化</Option>
          <Option :value="10">设备断电</Option>
          <Option :value="11">数据补传</Option>
          <Option :value="5">超速{{ searchItem.speed }}km/h</Option>
          <Option :value="6">ACC开无速度</Option>
          <Option :value="7">ACC关无速度</Option>
          <Option :value="8">ACC开有速度</Option>
          <Option :value="9">ACC关有速度</Option>
        </Select>
      </div>
      <template slot="btn">
        <Button @click="chaxun" type="primary" class="chaxun">查询</Button>
        <Button @click="addExportTask" class="chaxun" type="error">导出</Button>
        <Button @click="drawer" class="chaxun" type="success">图表</Button>
      </template>
    </selectTool>
    <div id="ana">
      <div id="anaLeft">
        <lyTable
          ref="lyTable"
          :columns="columns"
          :data="historyData"
          no-data-text="<div class='table-no-data'></div>"
          :height="utils.setTableHeight(220)"
        >
          <template slot-scope="{ row, index }" slot="address">
            <a v-if="utils.isEmpty(row.address)" @click="jiexi(row, index)"
              >解析当前地址</a
            >
            <span v-else>{{ row.address }}</span>
          </template>
        </lyTable>
        <div id="mypage">
          <div>
            <Page
              :current="1"
              :total="total"
              :page-size="searchItem.pageSize"
              :page-size-opts="[500, 1000, 2000, 3000, 5000]"
              show-total
              show-elevator
              show-sizer
              @on-change="changePage"
              @on-page-size-change="pageSizeChange"
            ></Page>
          </div>
        </div>
      </div>
      <div id="anaRight">
        <report :data="goalData" @tr="reTr"></report>
      </div>
    </div>
    <form-model title="设定速度值" width="400" ref="formModel">
      <Button slot="btn" type="primary" @click="findSpeed">确认</Button>
    </form-model>
    <exportLocus ref="exportLocus"></exportLocus>
    <Modal title="里程/速度/发动机图表" v-model="openForm" fullscreen footerHide>
      <history-chart ref="historyChart"></history-chart>
    </Modal>
  </div>
</template>
<script>
var t = 1;
import lyTable from "./lytable.vue";
import report from "./report.vue";
import exportLocus from "../locus/export.vue";
import historyChart from "./historyChart.vue";
export default {
  props: ["scan"],
  components: { lyTable, report, exportLocus, historyChart },
  data() {
    return {
      columns: [
        {
          key: "row",
          width: 70,
          align: "center",
          fixed: "left",
        },
        {
          title: "绑定主体",
          key: "name",
          minWidth: 70,
          maxWidth: 130,
          tooltip: true,
        },
        {
          title: "定位时间",
          key: "gpsTime2",
          align: "left",
          width: 150,
          tooltip: true,
        },
        {
          title: "上报时间",
          key: "reportTime2",
          align: "left",
          width: 150,
          tooltip: true,
        },
        {
          title: "信号",
          key: "flag1",
          align: "left",
          minWidth: 70,
          maxWidth: 130,
          tooltip: true,
        },
        {
          title: "发动机",
          key: "accStatus1",
          align: "left",
          minWidth: 70,
          maxWidth: 130,
        },
        {
          title: "速度/km/h",
          key: "speed",
          align: "left",
          minWidth: 70,
          maxWidth: 130,
          tooltip: true,
        },
        {
          title: "里程/km",
          key: "mileage",
          align: "left",
          minWidth: 70,
          maxWidth: 130,
          tooltip: true,
        },
        {
          title: "事件报告",
          key: "eventDesc",
          width: 200,
          tooltip: true,
        },
        {
          title: "油量电阻",
          key: "oil",
          align: "left",
          minWidth: 70,
          maxWidth: 130,
          tooltip: true,
        },

        {
          title: "原始经度(WGS-84)",
          key: "orgX",
          minWidth: 160,
          maxWidth: 200,
        },
        {
          title: "原始纬度(WGS-84)",
          key: "orgY",
          minWidth: 160,
          maxWidth: 200,
        },
        {
          title: "位置地址",
          slot: "address",
          align: "left",
          width: 300,
          tooltip: true,
        },
        {
          title: "方向度数",
          key: "directionDegree",
          align: "left",
          minWidth: 70,
          maxWidth: 130,
          tooltip: true,
        },
      ],
      tableData: [],
      historyData: [],
      total: 0,
      searchItem: {
        deviceNo: "",
        bind: "",
        model: 1, //分析用
        speed: 120, //分析用
        endTime: 0,
        startTime: 0,
        pageSize: 2000,
        pageNumber: 1,
        returnCoord: 2,
      },
      goalData: [],
      forms: [
        {
          title: "速度值km/h",
          key: "speed",
          type: "Input",
          required: true,
          span: 24,
        },
      ],
      useType: 1,
      openForm: false,
    };
  },
  methods: {
    reach(v) {
      this.searchItem.deviceNo = v.deviceNo;
      this.searchItem.bind = v.bind;
      //this.searchItem.start = v.start; //为导出备用
      //this.searchItem.end = v.end; //为导出备用
      this.$refs.startEnd.setTime(v);
      this.chaxun();
    },
    getList() {
      if (this.utils.isEmpty(this.searchItem.deviceNo)) {
        this.$Message.error("设备号必填");
        return;
      }
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.lbs + "/locus/getOrgLocus",
        data: {
          deviceNo: this.searchItem.deviceNo,
          endTime: this.searchItem.endTime,
          startTime: this.searchItem.startTime,
          //pageSize: 30,
          //pageNumber: 1,
          returnCoord: 2,
        },
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        if (res) {
          this.total = res.data.data.total;
          var data = res.data.data.dataList;

          for (let i = 0; i < data.length; i++) {
            data[i].name =
              data[i].personName == null ? data[i].carNo : data[i].personName;
            data[i].address = "";
            data[i].reMileage = Number(
              (data[i].mileage - data[data.length - 1].mileage).toFixed(2)
            );
            data[i].row = i + 1;
            data[i].accStatus1 = this.$t("accStatus." + data[i].accStatus);
            data[i].flag1 = this.$t("flag." + data[i].flag);
            data[i].parkDuration1 = this.utils.duration(data[i].parkDuration);
            data[i].gpsTime2 = this.utils.time(data[i].gpsTime);
            data[i].reportTime2 = this.utils.time(data[i].recordTime);
            data[i].startParkTime = this.utils.time(data[i].startParkTime);
            data[i].endParkTime = this.utils.time(data[i].endParkTime);
          }
          this.tableData = data;
          this.setPage();
        }
      });
    },
    drawer() {
      this.openForm = true;
      var list = [];
      var data = this.tableData;
      var list1 = [],
        list2 = [],
        list3 = [],
        list4 = [];
      for (const i in data) {
        var obj1 = {
          value: [
            data[i].gpsTime2,
            data[i].reMileage,
            data[i].mileage,
          ],
        };
        var obj2 = {
          value: [data[i].gpsTime2, data[i].speed],
        };
        var obj3 = {
          value: [data[i].gpsTime2, data[i].accStatus, data[i].accStatus1],
        };

        list1.push(obj1);
        list2.push(obj2);
        list3.push(obj3);
        //list4.push(obj4);
      }
      this.$refs.historyChart.reData(list1, list2, list3, list4);
    },
    setPage() {
      this.historyData = this.utils.page(
        this.searchItem.pageNumber,
        this.searchItem.pageSize,
        this.tableData
      );
      this.givColor();
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.setPage();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.setPage();
    },
    chaxun() {
      this.searchItem.startTime = this.$refs.startEnd.getTimeObj().start;
      this.searchItem.endTime = this.$refs.startEnd.getTimeObj().end;
      this.getList();
    },
    search() {
      this.reset();
      this.getList();
    },
    addExportTask() {
      if (this.utils.isEmpty(this.searchItem.deviceNo)) {
        this.$Message.error("设备号必填");
        return;
      }
      this.searchItem.startTime = this.$refs.startEnd.getTimeObj().start;
      this.searchItem.endTime = this.$refs.startEnd.getTimeObj().end;
      var v = {
        deviceNo: this.searchItem.deviceNo,
        //end: this.searchItem.end,
        end: this.searchItem.endTime,
        returnCoord: 2,
        //start: this.searchItem.start,
        start: this.searchItem.startTime,
        type: 2, ////类型（1-车辆运动轨迹，2-车辆原始轨迹，3-人员正常轨迹，4-人员原始轨迹）
      };
      var ttt = {
        1: "车辆",
        2: "人员",
      };
      v.tt = ttt[this.useType];
      this.$refs.exportLocus.reachData(v);
    },
    findLicheng() {
      this.reset();
      var x = this.columns;
      for (const i in x) {
        x[i].color = false;
        if (i == 7) {
          x[i].color = true;
        }
      }
      var m = this.historyData;
      for (let i = 0; i < m.length; i++) {
        m[i].color = false;
        if (i > 0 && m[i - 1].mileage - m[i].mileage < 0) {
          m[i - 1].color = true;
          this.goalData.push(m[i - 1]);
        }
      }
      this.$refs.lyTable.freshColor();
      //this.rowClassName(this.tableData[0], t);
      //for (let i = 0; i < this.tableData.length; i++) {}
    },
    findLixian() {
      this.reset();
      var x = this.columns;
      for (const i in x) {
        x[i].color = false;
        if (i == 2) {
          x[i].color = true;
        }
      }
      var m = this.historyData;
      for (let i = 0; i < m.length; i++) {
        m[i].color = false;
        if (i > 0 && m[i - 1].gpsTime - m[i].gpsTime > 15 * 60000) {
          m[i - 1].color = true;
          this.goalData.push(m[i - 1]);
        }
      }
      this.$refs.lyTable.freshColor();
    },
    findNoxinhao() {
      this.reset();
      var x = this.columns;
      for (const i in x) {
        x[i].color = false;
        if (i == 4) {
          x[i].color = true;
        }
      }
      t = 4;
      var m = this.historyData;
      for (let i = 0; i < m.length; i++) {
        m[i].color = false;
        if (m[i].flag == 0) {
          m[i].color = true;
          this.goalData.push(m[i]);
        }
      }
      this.$refs.lyTable.freshColor();
    },
    findAccChange() {
      this.reset();
      var x = this.columns;
      for (const i in x) {
        x[i].color = false;
        if (i == 5) {
          x[i].color = true;
        }
      }
      var m = this.historyData;
      for (let i = 0; i < m.length; i++) {
        m[i].color = false;
        if (i > 0 && m[i - 1].accStatus != m[i].accStatus) {
          m[i - 1].color = true;
          this.goalData.push(m[i - 1]);
        }
      }
      this.$refs.lyTable.freshColor();
    },
    findSpeed() {
      this.reset();
      var x = this.columns;
      for (const i in x) {
        x[i].color = false;
        if (i == 6) {
          x[i].color = true;
        }
      }
      var m = this.historyData;
      for (let i = 0; i < m.length; i++) {
        m[i].color = false;
        if (m[i].speed > this.searchItem.speed) {
          m[i].color = true;
          this.goalData.push(m[i]);
        }
      }
      this.$refs.lyTable.freshColor();
      this.$refs.formModel.close();
    },
    findStay() {
      this.reset();
      var x = this.columns;
      for (const i in x) {
        x[i].color = false;
        if (i == 5 || i == 6) {
          x[i].color = true;
        }
      }
      var m = this.historyData;
      for (let i = 0; i < m.length; i++) {
        m[i].color = false;
        if (m[i].accStatus == 1 && m[i].speed == 0) {
          m[i].color = true;
          this.goalData.push(m[i]);
        }
      }
      this.$refs.lyTable.freshColor();
    },
    findPark() {
      this.reset();
      var x = this.columns;
      for (const i in x) {
        x[i].color = false;
        if (i == 5 || i == 6) {
          x[i].color = true;
        }
      }
      var m = this.historyData;
      for (let i = 0; i < m.length; i++) {
        m[i].color = false;
        if (m[i].accStatus == 0 && m[i].speed == 0) {
          m[i].color = true;
          this.goalData.push(m[i]);
        }
      }
      this.$refs.lyTable.freshColor();
    },
    findRun() {
      this.reset();
      var x = this.columns;
      for (const i in x) {
        x[i].color = false;
        if (i == 5 || i == 6) {
          x[i].color = true;
        }
      }
      var m = this.historyData;
      for (let i = 0; i < m.length; i++) {
        m[i].color = false;
        if (m[i].accStatus == 1 && m[i].speed > 0) {
          m[i].color = true;
          this.goalData.push(m[i]);
        }
      }
      this.$refs.lyTable.freshColor();
    },
    findRun1() {
      this.reset();
      var x = this.columns;
      for (const i in x) {
        x[i].color = false;
        if (i == 5 || i == 6) {
          x[i].color = true;
        }
      }
      var m = this.historyData;
      for (let i = 0; i < m.length; i++) {
        m[i].color = false;
        if (m[i].accStatus == 0 && m[i].speed > 0) {
          m[i].color = true;
          this.goalData.push(m[i]);
        }
      }
      this.$refs.lyTable.freshColor();
    },
    findNoEle() {
      this.reset();
      var x = this.columns;
      for (const i in x) {
        x[i].color = false;
        if (i == 8) {
          x[i].color = true;
        }
      }
      var m = this.historyData;
      for (let i = 0; i < m.length; i++) {
        m[i].color = false;
        if (m[i].eventDesc.indexOf("断电") != -1) {
          m[i].color = true;
          this.goalData.push(m[i]);
        }
      }
      this.$refs.lyTable.freshColor();
    },
    findPush() {
      this.reset();
      var x = this.columns;
      for (const i in x) {
        x[i].color = false;
        if (i == 8) {
          x[i].color = true;
        }
      }
      var m = this.historyData;
      for (let i = 0; i < m.length; i++) {
        m[i].color = false;
        if (m[i].eventDesc.indexOf("补传") != -1) {
          m[i].color = true;
          this.goalData.push(m[i]);
        }
      }
      this.$refs.lyTable.freshColor();
    },
    givColor() {
      var v = this.searchItem.model;
      if (v == 1) {
        this.findLicheng();
      } else if (v == 2) {
        this.findLixian();
      } else if (v == 3) {
        this.findNoxinhao();
      } else if (v == 4) {
        this.findAccChange();
      } else if (v == 5) {
        this.findSpeed();
      } else if (v == 6) {
        this.findStay();
      } else if (v == 7) {
        this.findPark();
      } else if (v == 8) {
        this.findRun();
      } else if (v == 9) {
        this.findRun1();
      } else if (v == 10) {
        this.findNoEle();
      } else if (v == 11) {
        this.findPush();
      }
    },
    //选择下拉
    selectModel(row) {
      this.searchItem.model = row.value;
      if (row.value == 5) {
        this.$refs.formModel.reach(this.forms, this.searchItem);
        return;
      }
      this.givColor();
    },
    reset() {
      this.goalData = [];
    },
    reTr(v) {
      this.$refs.lyTable.scroll(v.row);
    },
    jiexi(row, index) {
      //row.address = 12345677;
      var pointList = [{ x: row.orgX, y: row.orgY }];
      this.utils.jiexi(pointList).then((data) => {
        for (const i in data) {
          row.address = data[i].address;
        }
      });
      console.log(row, index);
      //console.log(this.historyData[1].address);
      //console.log(this.historyData[2].address);
    },
  },
  mounted() {
    var config = {
      min: 100,
      max: 300,
    };
    this.columns = this.utils.cols([], this.columns, config);

    //this.chaxun();
  },
};
</script>
<style>
#ana {
  width: 100%;
  height: calc(100% - 200px);
  display: flex;
}
#anaLeft {
  height: 100%;
  width: calc(100% - 240px);
}
#anaRight {
  height: 100%;
  width: 240px;
}
</style>


// WEBPACK FOOTER //
// src/components/dataAnalyse/history.vue